import { UseFormRegister, FieldError } from "react-hook-form";
import { cn } from "../../lib/utils";

interface FormInputProps {
  id: string;
  label: string;
  type?: string;
  error?: FieldError;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  register: UseFormRegister<any>;
  className?: string;
  placeholder?: string;
  dataTestId?: string;
  isOptional?: boolean;
}

export default function FormInput({
  id,
  label,
  type = "text",
  error,
  register,
  className = "",
  placeholder,
  dataTestId,
  isOptional = false,
}: FormInputProps) {
  return (
    <div className={className}>
      <label htmlFor={id} className="block text-sm font-medium mb-1">
        {label}
        {isOptional ? (
          <span className="text-sm text-tertiary"> (optionnel)</span>
        ) : null}
      </label>
      <input
        placeholder={placeholder}
        {...register(id)}
        type={type}
        id={id}
        className={cn(
          "w-full p-2 rounded-md bg-input focus:outline-none focus:ring-2 focus:ring-card border border-border placeholder:text-tertiary",
          error && "border-red-500"
        )}
        data-testid={dataTestId}
        autoComplete="off"
      />
      {error && <p className="text-red-500 text-sm mt-1">{error.message}</p>}
    </div>
  );
}
